import { findIndex } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import './SelectableGrid.scss';

import OptionBtn from './OptionBtn';
import Checkbox from '../../Shared/Checkbox/Checkbox';

class SelectableGrid extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allSelected: false,
      selected: props.selectedOptions ? props.selectedOptions : [],
    };
  }

  componentDidUpdate() {
    const { onSelect } = this.props;
    const { allSelected, selected } = this.state;

    if (onSelect) {
      onSelect(selected, allSelected);
    }

    if (this.allSelected() && !allSelected) {
      this.setState({
        allSelected: true,
      });
    }
  }

  selectOption(selectedOption) {
    const { selectLimit } = this.props;
    const { selected } = this.state;
    const index = findIndex(selected, selectedOption);

    if (selectLimit && selected.length >= selectLimit) {
      this.setState({
        selected: selected.filter(function (option) {
          return option.value !== selectedOption.value;
        }),
      });
    } else {
      this.setState({
        selected:
          index > -1
            ? selected.filter(function (option) {
                return option.value !== selectedOption.value;
              })
            : [...selected, selectedOption],
      });
    }
  }

  toggleAllOptions() {
    const { options } = this.props;
    this.setState((prevState) => ({
      allSelected: !prevState.allSelected,
      selected: prevState.allSelected ? [] : options,
    }));
  }

  allSelected() {
    const { selected } = this.state;
    const { options } = this.props;
    return selected.length === options.length;
  }

  isSelected(option) {
    const { selected } = this.state;
    return findIndex(selected, option) > -1;
  }

  isMaxSelect() {
    const { selectLimit } = this.props;
    const { selected } = this.state;
    return selected.length >= selectLimit;
  }

  render() {
    const {
      phoneColNum,
      title,
      id,
      optionName,
      selectAll,
      options,
      btnSize,
      footer,
      limitText,
    } = this.props;
    return (
      <div>
        <div className="selectable-grid-title">{title}</div>
        <div className="selectable-grid-limit-text">{limitText}</div>
        <div className="selectable-grid-options-container">
          {options.map((option, i) => {
            return (
              <OptionBtn
                id={`${i}`}
                option={option}
                key={i}
                phoneColNum={phoneColNum}
                size={btnSize + 'px'}
                onClick={() => this.selectOption(option)}
                selected={this.isSelected(option)}
                disabled={this.isMaxSelect()}
              />
            );
          })}
          {limitText && (
            <div className="selectable-grid-phone-limit-text">{limitText}</div>
          )}
        </div>
        {selectAll && (
          <div className="selectable-grid-select-all-container">
            <div className="selectable-grid-select-all">
              <Checkbox
                id={`checkbox-all-options-${id}`}
                e2eSuffix={`select-all-options-${id}`}
                checked={this.allSelected()}
                onClick={() => this.toggleAllOptions()}
                ariaLabel={`Toggle All Options`}
                tabIndex={'0'}
                inline={true}
                contextStyle={{ marginTop: '5px' }}
                disabled={false}
              />
              <label
                htmlFor={`checkbox-all-options-${id}`}
                className="selectable-grid-select-all-option"
              >
                Select All {optionName}
              </label>
            </div>
            <div className="selectable-grid-select-all-phone">
              <OptionBtn
                id="select-all-option-btn"
                onClick={() => this.toggleAllOptions()}
                option={{
                  label: this.allSelected()
                    ? 'Deselect All ' + optionName
                    : 'Select All ' + optionName,
                  value: 0,
                }}
                selected={this.allSelected()}
                size={'100%'}
              />
            </div>
          </div>
        )}
        <div className="selectable-grid-footer-container">{footer}</div>
      </div>
    );
  }
}

SelectableGrid.defaultProps = {
  btnSize: 35,
  onSelect: () => {},
  selectAll: false,
};

SelectableGrid.propTypes = {
  btnSize: PropTypes.number,
  footer: PropTypes.any,
  id: PropTypes.string.isRequired,
  limitText: PropTypes.string,
  onSelect: PropTypes.func,
  optionName: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    })
  ).isRequired,
  phoneColNum: PropTypes.number,
  selectAll: PropTypes.bool,
};

export default SelectableGrid;
